import type {Theme, Components} from "../..";

declare module "@mui/material/Badge" {
    interface BadgeOwnProps {
        /**
         * prefixes sizes for badge.
         * Not applicable to dot badges.
         * @default 'default'
         */
        size?: "small" | "default";
        /**
         * Adds a border around the badge.
         * @default false
         */
        border?: boolean;
    }
}

type BadgeOverrides = Components<Theme>["MuiBadge"];

const overrides: BadgeOverrides = {
    styleOverrides: {
        anchorOriginTopLeftCircular: {
            top: "12%",
            left: "12%",
        },
        anchorOriginTopRightCircular: {
            top: "12%",
            right: "12%",
        },
        anchorOriginBottomLeftCircular: {
            bottom: "12%",
            left: "12%",
        },
        anchorOriginBottomRightCircular: {
            bottom: "12%",
            right: "12%",
        },
        badge: ({ownerState, theme}) => ({
            ...(ownerState.size === "small" &&
                ownerState.variant !== "dot" && {
                    padding: 0,
                    minWidth: 12,
                    width: 12,
                    height: 12,
                    fontSize: 8,
                }),

            ...(ownerState.border === true && {
                outline: `2px solid ${theme.color.border.inverted.strong}`,
                outlineOffset: -1,
            }),
        }),
        colorWarning: ({theme}) => ({
            backgroundColor: theme.color.fill.attention.strong,
            color: theme.color.text.inverted.default,
        }),
        colorSuccess: ({theme}) => ({
            backgroundColor: theme.color.fill.success.strong,
        }),
    },
    defaultProps: {
        size: "default",
        border: false,
    },
};

export default overrides;
